<script lang="ts">
  import { createEventDispatcher, onDestroy, setContext } from 'svelte';
  import CalendarAdaptForecastModal from './CalendarAdaptForecastModal.svelte';
  import AdaptForecastNeeded from './AdaptForecastNeeded.svelte';
  import { MedianAndWeatherStores, MyFitnessStores } from '../stores';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // Used by AdaptForecastDialog on a page that has no My Fitness stores: it sets up the stores
  // the dialog reads (the athlete's plan, calendar settings and training medians) and tells the page when the adapted
  // forecast was saved.
  export let data: { user_params: any; trainingPlan: any; cal_settings: any; training_medians: any };
  export let today: Date = new Date();

  const dispatch = createEventDispatcher();
  // Not 'logged in' to the live channels: the dialog only reads the stores, and a second subscription would never be closed.
  const stores = new MyFitnessStores(data.user_params, null, data.cal_settings, data.trainingPlan, false, false, false);
  setContext('myFitness', stores);
  setContext('medianAndWeather', new MedianAndWeatherStores(data.training_medians));

  // The dialog puts the saved plan in the store; resetting the chart puts the same object back, which is not a save.
  const loaded = data.trainingPlan;
  const unsubscribe = stores.trainingPlan.subscribe((plan: any) => {
    if (plan && plan !== loaded) dispatch('saved');
  });
  onDestroy(unsubscribe);

  // Whether Adapt Forecast is lit for this athlete (availability changed, or a day conflicts), told to the page.
  let needed = false;
  $: dispatch('lit', needed);

  let modal: any;
  export function openModal() {
    modal.openModal();
  }
</script>

<CalendarAdaptForecastModal bind:this={modal} forecastData={data.trainingPlan?.forecastResults?.inputs?.days ?? null} {today} />
<AdaptForecastNeeded showButton={false} bind:needed />
